import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    close: 'Exit',
    description:
      'Deposit your capital with Shine and receive your\ncertificate of deposit in under 72 hours.',
    steps: {
      accountOpened: {
        description: 'You can start now start working!',
        title: 'We open your Shine account and release your funds',
      },
      info: {
        description: 'This takes less than 2 business days ',
        title: 'We ask you some information and make legal verifications',
      },
      statutes: {
        description: 'You’ll have to send your statutes to the state',
        link: 'When do I get my Kbis?',
        title: 'You can then finish your company creation',
      },
      transfer: {
        description: 'Less than 72h after receiving your funds',
        link: 'What is a certificate of deposit?',
        title: 'You transfer your capital and get your certificate of deposit',
      },
    },
    title: 'Deposit your capital with Shine',
  },
  fr: {
    close: 'Fermer',
    description:
      'Déposez votre capital avec Shine et recevez votre\ncertificat de dépôt en moins de 72 heures.',
    steps: {
      accountOpened: {
        description:
          'C’est officiel, vous pouvez commencer à travailler\u00A0!',
        title: 'Nous libérons les fonds sur votre compte pro Shine',
      },
      info: {
        description: 'Cela prend moins de 2 jours ouvrés',
        title: 'Nous recueillons et vérifions vos informations',
      },
      statutes: {
        description:
          'Vous n’avez plus qu’à envoyer votre dossier à l’administration',
        link: 'Quand vais-je recevoir mon extrait Kbis\u00A0?',
        title: 'Vous finalisez votre création d’entreprise',
      },
      transfer: {
        description:
          'Nous vous envoyons l’attestation sous 72h après réception des fonds',
        link: 'Qu’est-ce qu’une attestation de dépôt\u00A0?',
        title:
          'Vous déposez votre capital et vous recevez votre attestation de dépôt',
      },
    },
    title: 'Déposez votre capital avec Shine',
  },
} as const);
